let lastScrollY = 0;
let lastScrollX = 0;

export function storeScrollPos(y = window.scrollY, x = window.scrollX) {
	lastScrollX = x;
	lastScrollY = y;
}

export function restoreScrollPos(y = lastScrollY, x = lastScrollX) {
	window.scrollTo(x, y);
}
